module.exports = __webpack_public_path__ + "static/img/19-中国农业大学附属小学.2613019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/19-中国农业大学附属小学.png
// module id = 9Egs
// module chunks = 0